<div class="u-flex">
  <form-control
    [control]="tempGroup.get(termsAndConditions.prop)"
    [config]="termsAndConditions"
    data-test-id="termsAndConditionsControl"
  >
  </form-control>
</div>
